import type { TranslationTag } from '@ps/web-core-intl';
import createDebug from 'debug';
import { useMemo } from 'react';
import { useLocale } from 'react-aria';

interface Translations {
  [key: string]: string;
}

const translationsCache: { [locale: string]: Translations } = {};

const loadTranslations = (locale: string): Translations => {
  if (!translationsCache[locale]) {
    try {
      translationsCache[locale] = require(`../../../../intl/${locale}.json`);
    } catch (error) {
      const debug = createDebug('fusion');
      debug(`Error loading translations for locale ${locale}:`, error);

      translationsCache[locale] = {};
    }
  }
  return translationsCache[locale];
};

const useTranslation = (translationTag: TranslationTag) => {
  const { locale } = useLocale();

  const translations = useMemo(() => {
    if (locale === 'en') {
      return {};
    }
    return loadTranslations(locale);
  }, [locale]);

  return translations[translationTag.id] || translationTag.defaultMessage;
};

export default useTranslation;
